import { firstValueFrom } from 'rxjs';
import { BudgetProviderService } from 'src/app/services/apps/budget/budget-provider.service';
import { BudgetTakerService } from 'src/app/services/apps/budget/budget-taker.service';
import {
  PageAbove,
  PageInfo,
} from 'src/assets/types/interface/page-info.interface';

export async function buildProposalPageInfo(
  proposalUuid: string,
  preferredBudgetUuid: string | null,
  tenantType: string,
  isApprover: boolean,
  isBuilder: boolean,
  budgetTakerService: BudgetTakerService,
  budgetProviderService: BudgetProviderService,
): Promise<PageInfo> {
  try {
    const request$ =
      tenantType === 'Tomador'
        ? budgetTakerService.getProposalDetails(
            proposalUuid,
            preferredBudgetUuid || 'latest',
          )
        : budgetProviderService.getProposalDetails(
            proposalUuid,
            preferredBudgetUuid || 'latest',
          );
    const proposal = await firstValueFrom(request$);
    const serviceOrderUuid = proposal.serviceOrder?.uuid ?? '';
    const serviceOrderNumber =
      proposal.serviceOrder?.number ?? proposal.osProvider?.number ?? '';
    const selectedStatus = proposal.selectedBudget?.status?.name ?? '';
    const approvalTab =
      selectedStatus === 'Aceite pendente' ? undefined : 'historico';

    const serviceOrderPage: PageAbove = isApprover
      ? {
          title: 'Ordem de Serviço: ',
          url: '/gestao/aprovacoes',
          queryParams: {
            tab: approvalTab,
            serviceOrderUuid,
            serviceOrderNumber,
            budgetUuid: proposal.selectedBudget?.uuid,
          },
          identification: serviceOrderNumber,
          description: 'Ordem de serviço nas aprovações',
        }
      : {
          title: 'Ordem de Serviço: ',
          url: `/gestao/ordem-servico/detalhes/${serviceOrderUuid}`,
          identification: serviceOrderNumber,
          description: 'Ordem de serviço do orçamento',
        };

    const pagesAbove: PageAbove[] = [serviceOrderPage];
    if (isBuilder) {
      pagesAbove.push({
        title: 'Revisões de Orçamento',
        url: `/gestao/orcamentos/${proposalUuid}`,
        description: 'Revisões da proposta',
      });
    }

    return {
      identification: '',
      title: isBuilder ? 'Novo orçamento' : 'Revisões de Orçamento',
      pagesAbove,
    };
  } catch (error) {
    console.error('Erro ao buscar detalhes da proposta:', error);
    return {
      identification: '',
      title: isBuilder ? 'Novo orçamento' : 'Revisões de Orçamento',
      pagesAbove: [],
    };
  }
}
